import { jsx } from "react/jsx-runtime";
import { useEffect, useRef } from "react";
function TabsScrollWrapper({ activeTabData, style = {}, children }) {
  const scrollRef = useRef();
  const isDraggingRef = useRef(false);
  useEffect(() => {
    const container = scrollRef.current;
    let isDown = false;
    let startX;
    let scrollLeft;
    const handleMouseDown = (e) => {
      isDown = true;
      isDraggingRef.current = false;
      container.classList.add("dragging");
      startX = e.pageX - container.offsetLeft;
      scrollLeft = container.scrollLeft;
    };
    const handleMouseMove = (e) => {
      if (!isDown)
        return;
      const x = e.pageX - container.offsetLeft;
      const walk = (x - startX) * 1;
      if (Math.abs(walk) > 5) {
        isDraggingRef.current = true;
      }
      container.scrollLeft = scrollLeft - walk;
    };
    const handleMouseUp = () => {
      isDown = false;
      container.classList.remove("dragging");
    };
    const handleClick = (e) => {
      if (isDraggingRef.current) {
        e.preventDefault();
        e.stopPropagation();
      }
    };
    container.addEventListener("mousedown", handleMouseDown);
    container.addEventListener("mousemove", handleMouseMove);
    container.addEventListener("mouseup", handleMouseUp);
    container.addEventListener("mouseleave", handleMouseUp);
    container.addEventListener("click", handleClick, true);
    return () => {
      container.removeEventListener("mousedown", handleMouseDown);
      container.removeEventListener("mousemove", handleMouseMove);
      container.removeEventListener("mouseup", handleMouseUp);
      container.removeEventListener("mouseleave", handleMouseUp);
      container.removeEventListener("click", handleClick, true);
    };
  }, []);
  useEffect(() => {
    scrollRef.current.scrollLeft = 0;
  }, [activeTabData]);
  return /* @__PURE__ */ jsx("div", { ref: scrollRef, className: "tabs-scroll-wrapper", style, children });
}
var stdin_default = TabsScrollWrapper;
export {
  stdin_default as default
};
